/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiControl.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-control";

export class AutogenModelEdiControl<RowType extends ModelRow> extends Endpoint<RowType, RowEdiControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiControl extends ModelRow<RowEdiControlFields> {
	constructor(values?: Partial<RowEdiControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiControlFields {
	app_srvr_timezone: string;
	company_id: string;
	id: number;
	srvr_time_disp: string;
}

